/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type MessagesInput = {
  messageId: string,
  message?: string | null,
  presentationId?: string | null,
  senderEmail?: string | null,
  senderName?: string | null,
  sentDate?: string | null,
  state?: MessageState | null,
  lastChanges?: string | null,
  presentationTitle?: string | null,
  prioritizeIndex?: number | null,
  senderStatus?: SenderStatus | null,
  aiResponse?: string | null,
  topic?: string | null,
};

export enum MessageState {
  REVIEW = "REVIEW",
  PRIORITIZED = "PRIORITIZED",
  PRESENTER = "PRESENTER",
  ANSWERED = "ANSWERED",
  REMOVED = "REMOVED",
}


export enum SenderStatus {
  PRESENTER = "PRESENTER",
  VIEWER = 'VIEWER',
  AI = 'AI'
}


export type Messages = {
  __typename: "Messages",
  messageId?: string | null,
  message?: string | null,
  presentationId?: string | null,
  senderEmail?: string | null,
  senderName?: string | null,
  sentDate?: string | null,
  state?: MessageState | null,
  lastChanges?: string | null,
  presentationTitle?: string | null,
  prioritizeIndex?: number | null,
  senderStatus?: SenderStatus | null,
  aiResponse?: string | null,
  topic?: string | null,
};

export type BatchMessageUpdatte = {
  __typename: "BatchMessageUpdatte",
  items?:  Array<Messages | null > | null,
  presentationId?: string | null,
};

export type InterfaceSettingsInput = {
  presentationId: string,
  reviewMode?: boolean | null,
};

export type InterfaceSettings = {
  __typename: "InterfaceSettings",
  presentationId?: string | null,
  reviewMode?: boolean | null,
};

export type ChatMessagesInput = {
  chatMessageId: string,
  presentationId: string,
  senderName: string,
  createdAt: string,
  message: string,
};

export type ChatMessages = {
  __typename: "ChatMessages",
  chatMessageId: string,
  presentationId: string,
  senderName: string,
  createdAt: string,
  message: string,
};

export type CommandsInput = {
  content?: string | null,
  livePresentationId: string,
  presentationId: string,
  concurrencyUserId?: string | null,
  currentSlideIndex?: number | null,
  userName?: string | null,
};

export type Commands = {
  __typename: "Commands",
  backup_stream?: boolean | null,
  backup_stream_time?: number | null,
  content?: string | null,
  stream_time?: number | null,
  type?: string | null,
  concurrencyUserId?: string | null,
  currentSlideIndex?: number | null,
  presentationId?: string | null,
  userName?: string | null,
};

export type PollInput = {
  pollId: string,
  hideForPresenter?: boolean | null,
  order?: number | null,
  status?: PollStatus | null,
  type?: PollType | null,
  value?: string | null,
  publicAdjustment?: number | null,
  poll_in_progress_timestamp?: string | null,
  poll_completed_timestamp?: string | null,
  result_slide_added?: boolean | null,
  resultsShared?: boolean | null,
};

export enum PollStatus {
  COMPLETED = "COMPLETED",
  IN_PROGRESS = "IN_PROGRESS",
  NOT_STARTED = "NOT_STARTED",
  CLOSED = "CLOSED",
  RESETED = "RESETED",
}


export enum PollType {
  SINGLE_CHOICE = "SINGLE_CHOICE",
  MULTIPLE_CHOICE = "MULTIPLE_CHOICE",
  FREEDOM_TEXT = "FREEDOM_TEXT",
  RATING = "RATING",
}


export type Poll = {
  __typename: "Poll",
  pollId: string,
  presentationId: string,
  hideForPresenter?: boolean | null,
  order?: number | null,
  status?: PollStatus | null,
  type?: PollType | null,
  value?: string | null,
  publicAdjustment?: number | null,
  poll_in_progress_timestamp?: string | null,
  poll_completed_timestamp?: string | null,
  countVotes?: number | null,
  result_slide_added?: boolean | null,
  resultsShared?: boolean | null,
};

export type PollChoicesInput = {
  pollId: string,
  pollChoiceId: string,
  isCustomResponse?: boolean | null,
  order?: number | null,
  value?: string | null,
  status?: PollChoiceStatus | null,
};

export enum PollChoiceStatus {
  ACTIVE = "ACTIVE",
  DELETED = "DELETED",
}


export type PollsResult = {
  __typename: "PollsResult",
  presentationId: string,
  Polls?:  Array<Poll | null > | null,
  PollChoices?:  Array<PollChoices | null > | null,
};

export type PollChoices = {
  __typename: "PollChoices",
  pollId: string,
  pollChoiceId: string,
  isCustomResponse?: boolean | null,
  order?: number | null,
  value?: string | null,
  status?: PollChoiceStatus | null,
  count?: number | null,
};

export enum PollCommand {
  START_POLL = "START_POLL",
  STOP_POLL = "STOP_POLL",
}


export type KnovioCommand = {
  __typename: "KnovioCommand",
  backup_stream?: boolean | null,
  backup_stream_time?: number | null,
  content?: string | null,
  stream_time?: number | null,
  type?: string | null,
  livePresentationId?: string | null,
  presentationId?: string | null,
};

export type CommandAdjustmentInput = {
  livePresentationId: number,
  isBackup?: boolean | null,
  backup_stream_time?: number | null,
  stream_time?: number | null,
};

export type CommandAdjustment = {
  __typename: "CommandAdjustment",
  backup_stream_time?: number | null,
  stream_time?: number | null,
};

export type PublishCommandInput = {
  livePresentationId: string,
  liveCommand?: PublishLiveCommand | null,
  presentation?: string | null,
};

export type PublishLiveCommand = {
  type?: string | null,
  backup_stream?: boolean | null,
  backup_stream_time?: number | null,
  stream_time?: number | null,
};

export type PublishCommandResponse = {
  __typename: "PublishCommandResponse",
  livePresentationId?: string | null,
  idHash?: string | null,
  presentationLink?: string | null,
  liveCommand?: PublishLiveCommandResponse | null,
};

export type PublishLiveCommandResponse = {
  __typename: "PublishLiveCommandResponse",
  type?: string | null,
  backup_stream?: boolean | null,
  backup_stream_time?: number | null,
  stream_time?: number | null,
};

export type KnovioCommandInput = {
  livePresentationId: string,
  backup_stream?: boolean | null,
  backup_stream_time?: number | null,
  content?: string | null,
  stream_time?: number | null,
  type?: string | null,
};

export type StartMediaLiveChannelInput = {
  channelId: string,
};

export type StreamData = {
  __typename: "StreamData",
  account_id?: number | null,
  channel_info?:  Array<ChannelInfo | null > | null,
  created_by_user?: number | null,
  created_date?: string | null,
  hls_link?: string | null,
  id?: number | null,
  live_stream_provider?: string | null,
  modified_by_user?: number | null,
  modified_date?: string | null,
  name?: string | null,
  presentation_id?: number | null,
  profile?: string | null,
  rtmp_input_id?: number | null,
  rtmp_link?: string | null,
  start_date?: string | null,
  state?: string | null,
  sync_flow?: string | null,
  unique_identifier?: string | null,
};

export type ChannelInfo = {
  __typename: "ChannelInfo",
  inputReceivedDate?: string | null,
  isSynced?: boolean | null,
  processingPipeline?: string | null,
};

export type AddMediaLiveChannelInput = {
  create_backup?: boolean | null,
  knovio_id: number,
  name?: string | null,
  provider?: string | null,
};

export type PollChoiceIdInput = {
  pollChoiceId: string,
};

export type PollVotesCountResult = {
  __typename: "PollVotesCountResult",
  pollVotesCount?:  Array<PollChoiceCount | null > | null,
  allVotesCount?: number | null,
  presentationId?: string | null,
  pollId?: string | null,
};

export type PollChoiceCount = {
  __typename: "PollChoiceCount",
  pollChoiceId?: string | null,
  count?: number | null,
};

export type PublishSegmentsInput = {
  segments: string,
  action: PublishSegmentsActionType,
  atIndex?: number | null,
};

export enum PublishSegmentsActionType {
  ADD = "ADD",
  REMOVE = "REMOVE",
  UPDATE = "UPDATE",
  REORDER = "REORDER",
  PURGE = "PURGE",
}


export type PublishSegments = {
  __typename: "PublishSegments",
  segments: string,
  action: PublishSegmentsActionType,
  atIndex?: number | null,
  presentationId: string,
};

export type MessagesConnection = {
  __typename: "MessagesConnection",
  items?:  Array<Messages | null > | null,
  nextToken?: string | null,
};

export type ChatMessagesConnection = {
  __typename: "ChatMessagesConnection",
  items?:  Array<ChatMessages | null > | null,
  nextToken?: string | null,
};

export type PollsConnection = {
  __typename: "PollsConnection",
  items?:  Array<Poll | null > | null,
  nextToken?: string | null,
};

export type PollChoiceConnection = {
  __typename: "PollChoiceConnection",
  pollChoicesCountedList?:  Array<PollChoices | null > | null,
  nextToken?: string | null,
  allVotesCount?: number | null,
};

export type PollVotesResult = {
  __typename: "PollVotesResult",
  items?:  Array<PollVote | null > | null,
};

export type PollVote = {
  __typename: "PollVote",
  pollId?: string | null,
  uniqueViewerId?: string | null,
  pollChoiceId?: string | null,
};

export type CreateMessagesMutationVariables = {
  input?: MessagesInput | null,
};

export type CreateMessagesMutation = {
  createMessages?:  {
    __typename: "Messages",
    messageId?: string | null,
    message?: string | null,
    presentationId?: string | null,
    senderEmail?: string | null,
    senderName?: string | null,
    sentDate?: string | null,
    state?: MessageState | null,
    lastChanges?: string | null,
    presentationTitle?: string | null,
    prioritizeIndex?: number | null,
    senderStatus?: SenderStatus | null,
    aiResponse?: string | null,
    topic?: string | null,
  } | null,
};

export type UpdateMessagesMutationVariables = {
  input?: MessagesInput | null,
};

export type UpdateMessagesMutation = {
  updateMessages?:  {
    __typename: "Messages",
    messageId?: string | null,
    message?: string | null,
    presentationId?: string | null,
    senderEmail?: string | null,
    senderName?: string | null,
    sentDate?: string | null,
    state?: MessageState | null,
    lastChanges?: string | null,
    presentationTitle?: string | null,
    prioritizeIndex?: number | null,
    senderStatus?: SenderStatus | null,
    aiResponse?: string | null,
    topic?: string | null,
  } | null,
};

export type DeleteMessagesMutationVariables = {
  messageId: string,
};

export type DeleteMessagesMutation = {
  deleteMessages?:  {
    __typename: "Messages",
    messageId?: string | null,
    message?: string | null,
    presentationId?: string | null,
    senderEmail?: string | null,
    senderName?: string | null,
    sentDate?: string | null,
    state?: MessageState | null,
    lastChanges?: string | null,
    presentationTitle?: string | null,
    prioritizeIndex?: number | null,
    senderStatus?: SenderStatus | null,
    aiResponse?: string | null,
    topic?: string | null,
  } | null,
};

export type UpdateBatchMessagesMutationVariables = {
  presentationId: string,
  input?: Array< MessagesInput | null > | null,
};

export type UpdateBatchMessagesMutation = {
  updateBatchMessages?:  {
    __typename: "BatchMessageUpdatte",
    items?:  Array< {
      __typename: "Messages",
      messageId?: string | null,
      message?: string | null,
      presentationId?: string | null,
      senderEmail?: string | null,
      senderName?: string | null,
      sentDate?: string | null,
      state?: MessageState | null,
      lastChanges?: string | null,
      presentationTitle?: string | null,
      prioritizeIndex?: number | null,
      senderStatus?: SenderStatus | null,
      aiResponse?: string | null,
      topic?: string | null,
    } | null > | null,
    presentationId?: string | null,
  } | null,
};

export type CreateInterfaceSettingsMutationVariables = {
  input?: InterfaceSettingsInput | null,
};

export type CreateInterfaceSettingsMutation = {
  createInterfaceSettings?:  {
    __typename: "InterfaceSettings",
    presentationId?: string | null,
    reviewMode?: boolean | null,
  } | null,
};

export type UpdateInterfaceSettingsMutationVariables = {
  input?: InterfaceSettingsInput | null,
};

export type UpdateInterfaceSettingsMutation = {
  updateInterfaceSettings?:  {
    __typename: "InterfaceSettings",
    presentationId?: string | null,
    reviewMode?: boolean | null,
  } | null,
};

export type CreateChatMessagesMutationVariables = {
  input: ChatMessagesInput,
};

export type CreateChatMessagesMutation = {
  createChatMessages?:  {
    __typename: "ChatMessages",
    chatMessageId: string,
    presentationId: string,
    senderName: string,
    createdAt: string,
    message: string,
  } | null,
};

export type CommandsMutationMutationVariables = {
  input?: CommandsInput | null,
};

export type CommandsMutationMutation = {
  commandsMutation?:  {
    __typename: "Commands",
    backup_stream?: boolean | null,
    backup_stream_time?: number | null,
    content?: string | null,
    stream_time?: number | null,
    type?: string | null,
    concurrencyUserId?: string | null,
    currentSlideIndex?: number | null,
    presentationId?: string | null,
    userName?: string | null,
  } | null,
};

export type UpdatePollMutationVariables = {
  poll?: PollInput | null,
  presentationId: string,
};

export type UpdatePollMutation = {
  updatePoll?:  {
    __typename: "Poll",
    pollId: string,
    presentationId: string,
    hideForPresenter?: boolean | null,
    order?: number | null,
    status?: PollStatus | null,
    type?: PollType | null,
    value?: string | null,
    publicAdjustment?: number | null,
    poll_in_progress_timestamp?: string | null,
    poll_completed_timestamp?: string | null,
    countVotes?: number | null,
    result_slide_added?: boolean | null,
  } | null,
};

export type CreatePollMutationVariables = {
  poll?: PollInput | null,
  pollChoices?: Array< PollChoicesInput | null > | null,
  presentationId: string,
};

export type CreatePollMutation = {
  createPoll?:  {
    __typename: "PollsResult",
    presentationId: string,
    Polls?:  Array< {
      __typename: "Poll",
      pollId: string,
      presentationId: string,
      hideForPresenter?: boolean | null,
      order?: number | null,
      status?: PollStatus | null,
      type?: PollType | null,
      value?: string | null,
      publicAdjustment?: number | null,
      poll_in_progress_timestamp?: string | null,
      poll_completed_timestamp?: string | null,
      countVotes?: number | null,
      result_slide_added?: boolean | null,
    } | null > | null,
    PollChoices?:  Array< {
      __typename: "PollChoices",
      pollId: string,
      pollChoiceId: string,
      isCustomResponse?: boolean | null,
      order?: number | null,
      value?: string | null,
      status?: PollChoiceStatus | null,
      count?: number | null,
    } | null > | null,
  } | null,
};

export type DeletePollMutationVariables = {
  pollId: string,
  presentationId: string,
};

export type DeletePollMutation = {
  deletePoll?:  {
    __typename: "PollsResult",
    presentationId: string,
    Polls?:  Array< {
      __typename: "Poll",
      pollId: string,
      presentationId: string,
      hideForPresenter?: boolean | null,
      order?: number | null,
      status?: PollStatus | null,
      type?: PollType | null,
      value?: string | null,
      publicAdjustment?: number | null,
      poll_in_progress_timestamp?: string | null,
      poll_completed_timestamp?: string | null,
      countVotes?: number | null,
      result_slide_added?: boolean | null,
    } | null > | null,
    PollChoices?:  Array< {
      __typename: "PollChoices",
      pollId: string,
      pollChoiceId: string,
      isCustomResponse?: boolean | null,
      order?: number | null,
      value?: string | null,
      status?: PollChoiceStatus | null,
      count?: number | null,
    } | null > | null,
  } | null,
};

export type UpdatePollAndPollChoicesMutationVariables = {
  poll?: PollInput | null,
  pollChoices?: Array< PollChoicesInput | null > | null,
  presentationId: string,
};

export type UpdatePollAndPollChoicesMutation = {
  updatePollAndPollChoices?:  {
    __typename: "PollsResult",
    presentationId: string,
    Polls?:  Array< {
      __typename: "Poll",
      pollId: string,
      presentationId: string,
      hideForPresenter?: boolean | null,
      order?: number | null,
      status?: PollStatus | null,
      type?: PollType | null,
      value?: string | null,
      publicAdjustment?: number | null,
      poll_in_progress_timestamp?: string | null,
      poll_completed_timestamp?: string | null,
      countVotes?: number | null,
      result_slide_added?: boolean | null,
    } | null > | null,
    PollChoices?:  Array< {
      __typename: "PollChoices",
      pollId: string,
      pollChoiceId: string,
      isCustomResponse?: boolean | null,
      order?: number | null,
      value?: string | null,
      status?: PollChoiceStatus | null,
      count?: number | null,
    } | null > | null,
  } | null,
};

export type PollCommandMutationVariables = {
  poll: PollInput,
  presentationId: string,
  livePresentationId: string,
  pollCommand: PollCommand,
};

export type PollCommandMutation = {
  pollCommand?:  {
    __typename: "KnovioCommand",
    backup_stream?: boolean | null,
    backup_stream_time?: number | null,
    content?: string | null,
    stream_time?: number | null,
    type?: string | null,
    livePresentationId?: string | null,
    presentationId?: string | null,
  } | null,
};

export type CommandAjustmentMutationVariables = {
  input?: CommandAdjustmentInput | null,
};

export type CommandAjustmentMutation = {
  commandAjustment?:  {
    __typename: "CommandAdjustment",
    backup_stream_time?: number | null,
    stream_time?: number | null,
  } | null,
};

export type PublishCommandMutationVariables = {
  input?: PublishCommandInput | null,
};

export type PublishCommandMutation = {
  publishCommand?:  {
    __typename: "PublishCommandResponse",
    livePresentationId?: string | null,
    idHash?: string | null,
    presentationLink?: string | null,
    liveCommand?:  {
      __typename: "PublishLiveCommandResponse",
      type?: string | null,
      backup_stream?: boolean | null,
      backup_stream_time?: number | null,
      stream_time?: number | null,
    } | null,
  } | null,
};

export type KnovioCommandMutationVariables = {
  input?: KnovioCommandInput | null,
};

export type KnovioCommandMutation = {
  knovioCommand?:  {
    __typename: "KnovioCommand",
    backup_stream?: boolean | null,
    backup_stream_time?: number | null,
    content?: string | null,
    stream_time?: number | null,
    type?: string | null,
    livePresentationId?: string | null,
    presentationId?: string | null,
  } | null,
};

export type StartMediaLiveChannelMutationVariables = {
  input?: StartMediaLiveChannelInput | null,
};

export type StartMediaLiveChannelMutation = {
  startMediaLiveChannel?:  {
    __typename: "StreamData",
    account_id?: number | null,
    channel_info?:  Array< {
      __typename: "ChannelInfo",
      inputReceivedDate?: string | null,
      isSynced?: boolean | null,
      processingPipeline?: string | null,
    } | null > | null,
    created_by_user?: number | null,
    created_date?: string | null,
    hls_link?: string | null,
    id?: number | null,
    live_stream_provider?: string | null,
    modified_by_user?: number | null,
    modified_date?: string | null,
    name?: string | null,
    presentation_id?: number | null,
    profile?: string | null,
    rtmp_input_id?: number | null,
    rtmp_link?: string | null,
    start_date?: string | null,
    state?: string | null,
    sync_flow?: string | null,
    unique_identifier?: string | null,
  } | null,
};

export type AddMediaLiveChannelMutationVariables = {
  input?: AddMediaLiveChannelInput | null,
};

export type AddMediaLiveChannelMutation = {
  addMediaLiveChannel?:  {
    __typename: "StreamData",
    account_id?: number | null,
    channel_info?:  Array< {
      __typename: "ChannelInfo",
      inputReceivedDate?: string | null,
      isSynced?: boolean | null,
      processingPipeline?: string | null,
    } | null > | null,
    created_by_user?: number | null,
    created_date?: string | null,
    hls_link?: string | null,
    id?: number | null,
    live_stream_provider?: string | null,
    modified_by_user?: number | null,
    modified_date?: string | null,
    name?: string | null,
    presentation_id?: number | null,
    profile?: string | null,
    rtmp_input_id?: number | null,
    rtmp_link?: string | null,
    start_date?: string | null,
    state?: string | null,
    sync_flow?: string | null,
    unique_identifier?: string | null,
  } | null,
};

export type SavePollVotesMutationVariables = {
  presentationId: string,
  pollId: string,
  uniqueViewerId: string,
  pollChoiceIds?: Array< PollChoiceIdInput | null > | null,
};

export type SavePollVotesMutation = {
  savePollVotes?:  {
    __typename: "PollVotesCountResult",
    pollVotesCount?:  Array< {
      __typename: "PollChoiceCount",
      pollChoiceId?: string | null,
      count?: number | null,
    } | null > | null,
    allVotesCount?: number | null,
    presentationId?: string | null,
    pollId?: string | null,
  } | null,
};

export type PublishSegmentsMutationVariables = {
  input: PublishSegmentsInput,
  presentationId: string,
};

export type PublishSegmentsMutation = {
  publishSegments?:  {
    __typename: "PublishSegments",
    segments: string,
    action: PublishSegmentsActionType,
    atIndex?: number | null,
    presentationId: string,
  } | null,
};

export type PublishSegmentsPresenterMutationVariables = {
  input: PublishSegmentsInput,
  presentationId: string,
};

export type PublishSegmentsPresenterMutation = {
  publishSegmentsPresenter?:  {
    __typename: "PublishSegments",
    segments: string,
    action: PublishSegmentsActionType,
    atIndex?: number | null,
    presentationId: string,
  } | null,
};

export type GetMessagesQueryVariables = {
  messageId: string,
};

export type GetMessagesQuery = {
  getMessages?:  {
    __typename: "Messages",
    messageId?: string | null,
    message?: string | null,
    presentationId?: string | null,
    senderEmail?: string | null,
    senderName?: string | null,
    sentDate?: string | null,
    state?: MessageState | null,
    lastChanges?: string | null,
    presentationTitle?: string | null,
    prioritizeIndex?: number | null,
    senderStatus?: SenderStatus | null,
    aiResponse?: string | null,
    topic?: string | null,
  } | null,
};

export type ListMessagesQueryVariables = {
  presentationId: string,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: string | null,
};

export type ListMessagesQuery = {
  listMessages?:  {
    __typename: "MessagesConnection",
    items?:  Array< {
      __typename: "Messages",
      messageId?: string | null,
      message?: string | null,
      presentationId?: string | null,
      senderEmail?: string | null,
      senderName?: string | null,
      sentDate?: string | null,
      state?: MessageState | null,
      lastChanges?: string | null,
      presentationTitle?: string | null,
      prioritizeIndex?: number | null,
      senderStatus?: SenderStatus | null,
      aiResponse?: string | null,
      topic?: string | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetInterfaceSettingsQueryVariables = {
  presentationId: string,
};

export type GetInterfaceSettingsQuery = {
  getInterfaceSettings?:  {
    __typename: "InterfaceSettings",
    presentationId?: string | null,
    reviewMode?: boolean | null,
  } | null,
};

export type GetChatMessagesQueryVariables = {
  chatMessageId: string,
};

export type GetChatMessagesQuery = {
  getChatMessages?:  {
    __typename: "ChatMessages",
    chatMessageId: string,
    presentationId: string,
    senderName: string,
    createdAt: string,
    message: string,
  } | null,
};

export type ListChatMessagesQueryVariables = {
  presentationId: string,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: string | null,
};

export type ListChatMessagesQuery = {
  listChatMessages?:  {
    __typename: "ChatMessagesConnection",
    items?:  Array< {
      __typename: "ChatMessages",
      chatMessageId: string,
      presentationId: string,
      senderName: string,
      createdAt: string,
      message: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetPollQueryVariables = {
  presentationId: string,
  pollId: string,
};

export type GetPollQuery = {
  getPoll?:  {
    __typename: "Poll",
    pollId: string,
    presentationId: string,
    hideForPresenter?: boolean | null,
    order?: number | null,
    status?: PollStatus | null,
    type?: PollType | null,
    value?: string | null,
    publicAdjustment?: number | null,
    poll_in_progress_timestamp?: string | null,
    poll_completed_timestamp?: string | null,
    countVotes?: number | null,
    result_slide_added?: boolean | null,
  } | null,
};

export type ListPollsQueryVariables = {
  presentationId: string,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: string | null,
};

export type ListPollsQuery = {
  listPolls?:  {
    __typename: "PollsConnection",
    items?:  Array< {
      __typename: "Poll",
      pollId: string,
      presentationId: string,
      hideForPresenter?: boolean | null,
      order?: number | null,
      status?: PollStatus | null,
      type?: PollType | null,
      value?: string | null,
      publicAdjustment?: number | null,
      poll_in_progress_timestamp?: string | null,
      poll_completed_timestamp?: string | null,
      countVotes?: number | null,
      result_slide_added?: boolean | null,
      resultsShared?: boolean | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListPollChoicesQueryVariables = {
  pollId: string,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: string | null,
};

export type ListPollChoicesQuery = {
  listPollChoices?:  {
    __typename: "PollChoiceConnection",
    pollChoicesCountedList?:  Array< {
      __typename: "PollChoices",
      pollId: string,
      pollChoiceId: string,
      isCustomResponse?: boolean | null,
      order?: number | null,
      value?: string | null,
      status?: PollChoiceStatus | null,
      count?: number | null,
    } | null > | null,
    nextToken?: string | null,
    allVotesCount?: number | null,
  } | null,
};

export type GetMediaLiveChannelStatusQueryVariables = {
  channelId: string,
};

export type GetMediaLiveChannelStatusQuery = {
  getMediaLiveChannelStatus?:  {
    __typename: "StreamData",
    account_id?: number | null,
    channel_info?:  Array< {
      __typename: "ChannelInfo",
      inputReceivedDate?: string | null,
      isSynced?: boolean | null,
      processingPipeline?: string | null,
    } | null > | null,
    created_by_user?: number | null,
    created_date?: string | null,
    hls_link?: string | null,
    id?: number | null,
    live_stream_provider?: string | null,
    modified_by_user?: number | null,
    modified_date?: string | null,
    name?: string | null,
    presentation_id?: number | null,
    profile?: string | null,
    rtmp_input_id?: number | null,
    rtmp_link?: string | null,
    start_date?: string | null,
    state?: string | null,
    sync_flow?: string | null,
    unique_identifier?: string | null,
  } | null,
};

export type GetPollVoteByUniqueViewerIdAndPollIdQueryVariables = {
  uniqueViewerId: string,
  pollId: string,
  presentationId: number,
};

export type GetPollVoteByUniqueViewerIdAndPollIdQuery = {
  getPollVoteByUniqueViewerIdAndPollId?:  {
    __typename: "PollVotesResult",
    items?:  Array< {
      __typename: "PollVote",
      pollId?: string | null,
      uniqueViewerId?: string | null,
      pollChoiceId?: string | null,
    } | null > | null,
  } | null,
};

export type GetAttendeesQueryVariables = {
  input: string,
};

export type GetAttendeesQuery = {
  getAttendees?: string | null,
};

export type GetActiveAttendeesCountQueryVariables = {
  input: string,
};

export type GetActiveAttendeesCountQuery = {
  getActiveAttendeesCount?: string | null,
};

export type OnCreateMessagesSubscriptionVariables = {
  presentationId: string,
};

export type OnCreateMessagesSubscription = {
  onCreateMessages?:  {
    __typename: "Messages",
    messageId?: string | null,
    message?: string | null,
    presentationId?: string | null,
    senderEmail?: string | null,
    senderName?: string | null,
    sentDate?: string | null,
    state?: MessageState | null,
    lastChanges?: string | null,
    presentationTitle?: string | null,
    prioritizeIndex?: number | null,
    senderStatus?: SenderStatus | null,
    aiResponse?: string | null,
    topic?: string | null,
  } | null,
};

export type OnUpdateMessagesSubscriptionVariables = {
  presentationId: string,
};

export type OnUpdateMessagesSubscription = {
  onUpdateMessages?:  {
    __typename: "Messages",
    messageId?: string | null,
    message?: string | null,
    presentationId?: string | null,
    senderEmail?: string | null,
    senderName?: string | null,
    sentDate?: string | null,
    state?: MessageState | null,
    lastChanges?: string | null,
    presentationTitle?: string | null,
    prioritizeIndex?: number | null,
    senderStatus?: SenderStatus | null,
    aiResponse?: string | null,
    topic?: string | null,
  } | null,
};

export type OnDeleteMessagesSubscriptionVariables = {
  presentationId: string,
};

export type OnDeleteMessagesSubscription = {
  onDeleteMessages?:  {
    __typename: "Messages",
    messageId?: string | null,
    message?: string | null,
    presentationId?: string | null,
    senderEmail?: string | null,
    senderName?: string | null,
    sentDate?: string | null,
    state?: MessageState | null,
    lastChanges?: string | null,
    presentationTitle?: string | null,
    prioritizeIndex?: number | null,
    senderStatus?: SenderStatus | null,
    aiResponse?: string | null,
    topic?: string | null,
  } | null,
};

export type OnBatchUpdateMessagesSubscriptionVariables = {
  presentationId: string,
};

export type OnBatchUpdateMessagesSubscription = {
  onBatchUpdateMessages?:  {
    __typename: "BatchMessageUpdatte",
    items?:  Array< {
      __typename: "Messages",
      messageId?: string | null,
      message?: string | null,
      presentationId?: string | null,
      senderEmail?: string | null,
      senderName?: string | null,
      sentDate?: string | null,
      state?: MessageState | null,
      lastChanges?: string | null,
      presentationTitle?: string | null,
      prioritizeIndex?: number | null,
      senderStatus?: SenderStatus | null,
      aiResponse?: string | null,
      topic?: string | null,
    } | null > | null,
    presentationId?: string | null,
  } | null,
};

export type OnCreateInterfaceSettingsSubscriptionVariables = {
  presentationId: string,
};

export type OnCreateInterfaceSettingsSubscription = {
  onCreateInterfaceSettings?:  {
    __typename: "InterfaceSettings",
    presentationId?: string | null,
    reviewMode?: boolean | null,
  } | null,
};

export type OnUpdateInterfaceSettingsSubscriptionVariables = {
  presentationId: string,
};

export type OnUpdateInterfaceSettingsSubscription = {
  onUpdateInterfaceSettings?:  {
    __typename: "InterfaceSettings",
    presentationId?: string | null,
    reviewMode?: boolean | null,
  } | null,
};

export type OnCreateChatMessagesSubscriptionVariables = {
  presentationId: string,
};

export type OnCreateChatMessagesSubscription = {
  onCreateChatMessages?:  {
    __typename: "ChatMessages",
    chatMessageId: string,
    presentationId: string,
    senderName: string,
    createdAt: string,
    message: string,
  } | null,
};

export type OnChangeSlidesSubscriptionVariables = {
  presentationId: string,
};

export type OnChangeSlidesSubscription = {
  onChangeSlides?:  {
    __typename: "Commands",
    backup_stream?: boolean | null,
    backup_stream_time?: number | null,
    content?: string | null,
    stream_time?: number | null,
    type?: string | null,
    concurrencyUserId?: string | null,
    currentSlideIndex?: number | null,
    presentationId?: string | null,
    userName?: string | null,
  } | null,
};

export type OnUpdatePollSubscriptionVariables = {
  presentationId: string,
};

export type OnUpdatePollSubscription = {
  onUpdatePoll?:  {
    __typename: "Poll",
    pollId: string,
    presentationId: string,
    hideForPresenter?: boolean | null,
    order?: number | null,
    status?: PollStatus | null,
    type?: PollType | null,
    value?: string | null,
    publicAdjustment?: number | null,
    poll_in_progress_timestamp?: string | null,
    poll_completed_timestamp?: string | null,
    countVotes?: number | null,
    result_slide_added?: boolean | null,
  } | null,
};

export type OnCreatePollSubscriptionVariables = {
  presentationId: string,
};

export type OnCreatePollSubscription = {
  onCreatePoll?:  {
    __typename: "PollsResult",
    presentationId: string,
    Polls?:  Array< {
      __typename: "Poll",
      pollId: string,
      presentationId: string,
      hideForPresenter?: boolean | null,
      order?: number | null,
      status?: PollStatus | null,
      type?: PollType | null,
      value?: string | null,
      publicAdjustment?: number | null,
      poll_in_progress_timestamp?: string | null,
      poll_completed_timestamp?: string | null,
      countVotes?: number | null,
      result_slide_added?: boolean | null,
    } | null > | null,
    PollChoices?:  Array< {
      __typename: "PollChoices",
      pollId: string,
      pollChoiceId: string,
      isCustomResponse?: boolean | null,
      order?: number | null,
      value?: string | null,
      status?: PollChoiceStatus | null,
      count?: number | null,
    } | null > | null,
  } | null,
};

export type OnDeletePollSubscriptionVariables = {
  presentationId: string,
};

export type OnDeletePollSubscription = {
  onDeletePoll?:  {
    __typename: "PollsResult",
    presentationId: string,
    Polls?:  Array< {
      __typename: "Poll",
      pollId: string,
      presentationId: string,
      hideForPresenter?: boolean | null,
      order?: number | null,
      status?: PollStatus | null,
      type?: PollType | null,
      value?: string | null,
      publicAdjustment?: number | null,
      poll_in_progress_timestamp?: string | null,
      poll_completed_timestamp?: string | null,
      countVotes?: number | null,
      result_slide_added?: boolean | null,
    } | null > | null,
    PollChoices?:  Array< {
      __typename: "PollChoices",
      pollId: string,
      pollChoiceId: string,
      isCustomResponse?: boolean | null,
      order?: number | null,
      value?: string | null,
      status?: PollChoiceStatus | null,
      count?: number | null,
    } | null > | null,
  } | null,
};

export type OnPollCommandSubscriptionVariables = {
  presentationId: string,
};

export type OnPollCommandSubscription = {
  onPollCommand?:  {
    __typename: "KnovioCommand",
    backup_stream?: boolean | null,
    backup_stream_time?: number | null,
    content?: string | null,
    stream_time?: number | null,
    type?: string | null,
    livePresentationId?: string | null,
    presentationId?: string | null,
  } | null,
};

export type OnSavePollVotesSubscriptionVariables = {
  presentationId: string,
};

export type OnSavePollVotesSubscription = {
  onSavePollVotes?:  {
    __typename: "PollVotesCountResult",
    pollVotesCount?:  Array< {
      __typename: "PollChoiceCount",
      pollChoiceId?: string | null,
      count?: number | null,
    } | null > | null,
    allVotesCount?: number | null,
    presentationId?: string | null,
    pollId?: string | null,
  } | null,
};

export type OnPublishSegmentsSubscriptionVariables = {
  presentationId: string,
};

export type OnPublishSegmentsSubscription = {
  onPublishSegments?:  {
    __typename: "PublishSegments",
    segments: string,
    action: PublishSegmentsActionType,
    atIndex?: number | null,
    presentationId: string,
  } | null,
};

export type OnKnovioPublishCommandSubscriptionVariables = {
  livePresentationId: string,
};

export type OnKnovioPublishCommandSubscription = {
  onKnovioPublishCommand?:  {
    __typename: "PublishCommandResponse",
    livePresentationId?: string | null,
    idHash?: string | null,
    presentationLink?: string | null,
    liveCommand?:  {
      __typename: "PublishLiveCommandResponse",
      type?: string | null,
      backup_stream?: boolean | null,
      backup_stream_time?: number | null,
      stream_time?: number | null,
    } | null,
  } | null,
};

export type OnKnovioCommandSubscriptionVariables = {
  livePresentationId: string,
};

export type OnKnovioCommandSubscription = {
  onKnovioCommand?:  {
    __typename: "KnovioCommand",
    backup_stream?: boolean | null,
    backup_stream_time?: number | null,
    content?: string | null,
    stream_time?: number | null,
    type?: string | null,
    livePresentationId?: string | null,
    presentationId?: string | null,
  } | null,
};
